import { Link, useLocation } from 'react-router-dom';

const tabs = [
	{ label: 'Browse Files', path: '/data/browse' },
	{ label: 'Export Data', path: '/data/export' },
	{ label: 'Farmer Data', path: '/data/farmer-data' },
];

export function DataTabs() {
	const { pathname } = useLocation();
	return (
		<div className="flex border-b border-gray-200 mb-6">
			{tabs.map(tab => (
				<Link
					key={tab.path}
					to={tab.path}
					className={`px-5 py-3 text-sm font-medium border-b-2 transition-colors ${
						pathname === tab.path
							? 'border-smartfield text-smartfield'
							: 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
					}`}
				>
					{tab.label}
				</Link>
			))}
		</div>
	);
}
